import React, { useState, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import useColor from "../../context/themeContext";
import useDragBatch from "../../hooks/useDragBatch";
import serviceAdmin from "../../services/serviceAdmin";
import ModalTeachingMaterial from "../Modal/ModalTeachingMaterial";


const TeachingMaterial = (props) => {
    const { COLORS } = useColor();
    const useStyles = makeStyles({
      title: {
        color: "#4c23f1",
        fontSize: "20px",
        fontWeight: "bold",
        paddingBottom: "10px",
      },
      subtitle: {
            fontWeight: "bold",
            paddingBottom: "10px"
        },
      color: {
                 color: COLORS.primary + "!important"
      },
      card: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
        borderRadius: "12px",
         backgroundColor: COLORS.primary,
        color: "#fff",
        marginBottom: "12px",
        cursor: "grab",
      },
      cardSection: {
        flex: 1,
        textAlign: "center",
      },
    });
  const classes = useStyles();

  const [openMaterial, setOpenMaterial] = useState(false);
  const [materials, setMaterials] = useState([]);
  const [reloadFlag, setReloadFlag] = useState(true);
  const [confirm, setConfirm] = useState(false);
  const [materialIdToDelete, setMaterialIdToDelete] = useState(null);

  const courseId = props.course?.id;

  const setconfirm = (input, material) => {
    setConfirm(input);
    setMaterialIdToDelete(material ? material.id : null);
  };

  const setreload = () => setReloadFlag(true);
  const setopenmaterial = () => setOpenMaterial(true);

  // fetch materials
  useEffect(() => {
    let mounted = true;
    if (reloadFlag && courseId) {
      serviceAdmin
        .getService(`v1/courses/${courseId}/teaching-materials/`)
        .then((res) => {
          if (!mounted) return;
          if (res.status === 200 && res.data && res.data.data) {
            setMaterials(res.data.data);
            setReloadFlag(false);
          }
        })
        .catch((err) => {
          console.error("fetch materials error", err);
        });
    }
    return () => {
      mounted = false;
    };
  }, [reloadFlag, courseId]);

  // delete flow
  useEffect(() => {
    let mounted = true;
    if (confirm && materialIdToDelete && courseId) {
      serviceAdmin
        .deleteService(`v1/courses/${courseId}/teaching-materials/${materialIdToDelete}/`)
        .then((res) => {
          if (!mounted) return;
          if (res.status === 200) {
            props.setCustomAlert(true, "success", "Materiale eliminato correttamente!");
            setreload();
            setConfirm(false);
            setMaterialIdToDelete(null);
          }
        })
        .catch((err) => {
          console.error("delete material error", err);
        });
    }
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm, materialIdToDelete]);

  // onReorder function -> will be called once by the hook with the full payload
  const onReorder = useCallback(async ({ course, order }) => {
    // ensure endpoint and body are correct; serviceAdmin should set Content-Type: application/json
    const endpoint = `v1/courses/${course}/teaching-materials/reorder/`;
    const body = { course, order }; // order = [{id,order},...]
    try {
      const res = await serviceAdmin.postService(endpoint, body);
      // return the promise result so hook can await it
      return res;
    } catch (err) {
      console.error("onReorder error", err);
      throw err;
    }
  }, []);

  // use the new hook
  const { DropContainer, DropElement, dragClass } = useDragBatch(
    "teaching-material-drag-handle",
    materials,
    setMaterials,
    onReorder,
    { debounceMs: 250, reload: setreload }
  );

  return (
    <div>
      <h2 className="title_corsi_admin">
        Materiale del corso <span style={{ color: COLORS.primary }}>{props.course?.name}</span>
      </h2>
      <div className={"subscription_course"} style={{ color: COLORS.primary }}>
        Aggiungi materiale didattico{" "}
        <AddCircleIcon onClick={setopenmaterial} className={"subscription_icon"} style={{ color: COLORS.primary }} />
      </div>

      <DropContainer>
        {materials.map((material) => (
          <DropElement key={material.id}>
            <div className={classes.card + " " + dragClass}>
              <div className={classes.cardSection}>{material.name}</div>
              <div className={classes.cardSection}>{material.type}</div>
              <div className={classes.cardSection}>
                {material.created ? new Date(material.created).toLocaleString() : "-"}
              </div>
              <Tooltip title="Elimina" placement="top">
                <IconButton onClick={() => setconfirm(true, material)} style={{ color: "#fff" }}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </div>
          </DropElement>
        ))}
      </DropContainer>

      <ModalTeachingMaterial
        setCustomAlert={props.setCustomAlert}
        course_id={courseId}
        open={openMaterial}
        setOpen={setOpenMaterial}
        setReload={setreload}
      />
    </div>
  );
};

export default TeachingMaterial;
